import { apiGet } from 'api';
import { DfiReportsResponse } from 'types';

export const getDfiAnnualReports = (): Promise<DfiReportsResponse> =>
  apiGet<DfiReportsResponse>('reports/dfiAnnual');
